import React, { Component } from "react";
import CarsListItem from "./carsListItem";
import { withRouter } from "react-router";
import { withChoosedCar } from "./../../../shared/containers/containerChoosedCar";

import styles from "./carsList.module.scss";
import CarListItemPanel from "./CarListItemPanel/CarListItemPanel";
import { withGeozones } from "../../../shared/containers/geozonesContainer";
import { withCompanyGroups } from "../../../shared/containers/containerCompanyGroups";

class CarsListItems extends Component {
  componentDidMount() {
    const {
      data,
      onChooseCar,
      onClearChoosedCar,
      match,
      choosedCarId,
      selectedTripUnitId,
      selectedTripId,
      onSelectToChangeUnit,
    } = this.props;

    if (choosedCarId === null && window.location.pathname.includes("/cars")) {
      const id = window.location.pathname.split("/")[2];

      const choseCar = data.filter((x) => {
        return x.id === id;
      })[0];

      if (choseCar !== undefined) {
        onChooseCar(choseCar);
      }
    } else if (choosedCarId !== null && window.location.pathname.includes("/cars") && !window.location.pathname.includes("/cars/")) {
      onClearChoosedCar();
    }
  }

  componentDidUpdate(prevProps) {
    const { onClearChoosedCar, choosedCarId } = this.props;

    if (choosedCarId !== null && !window.location.pathname.includes("/cars/")) {
      onClearChoosedCar();
    }
  }

  isAddMode() {
    const { selectGeozone, selectedGroup } = this.props;

    return selectGeozone !== null || selectedGroup !== null;
  }

  render() {
    const { handleScrollTo, data, choosedCarId, match } = this.props;

    return data.map((item) => {
      return (
        <div
          className={`
        ${styles.container_carsListItem}
        ${choosedCarId === item.id ? " selected_container_carsListItem" : ""}
        ${match.params.id === item.id ? " opened_container_carsListItem" : ""}
        `}
          key={item.id}
        >
          {!this.isAddMode() ? (
            <CarListItemPanel data={item} handleScrollTo={handleScrollTo} />
          ) : (
            <CarsListItem data={item} handleScrollTo={handleScrollTo} />
          )}
        </div>
      );
    });
  }
}

export default withCompanyGroups(withGeozones(withChoosedCar(withRouter(React.memo(CarsListItems)))));
